import React, { useState } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import { CSSTransition, TransitionGroup } from 'react-transition-group';

import PerfectScrollbar from 'react-perfect-scrollbar';
import HeaderLogo from 'components/Header/AppLogo';

import SidebarMenu from '../AppNav/SidebarMenu';
import { setEnableMobileMenu } from '../../store/reducers/ThemeOptions';

const sidebarStyles = {
	base: {
		transition: 'opacity 1.5s ease-in-out',
		opacity: 0,
	},
	appear: {
		opacity: 1,
	},
};

const AppSidebar = (props) => {
	const [enableMobileMenu, setEnableMobileMenu] = useState(false);

	const toggleMobileSidebar = () => {
		setEnableMobileMenu(!enableMobileMenu);
	};

	return (
		<React.Fragment>
			<div className="sidebar-mobile-overlay" onClick={toggleMobileSidebar} />
			<TransitionGroup component={null}>
				<CSSTransition
					timeout={{ appear: 1500, enter: 0, exit: 0 }}
					appear
				>
					<div
						style={{
							...sidebarStyles.base,
							...(sidebarStyles.appear),
						}}
						className={cx('app-sidebar', { 'sidebar-shadow': true })}
					>
						<HeaderLogo />
						<PerfectScrollbar>
							<div className="app-sidebar__inner">
								<SidebarMenu schoolTypeId={props.schoolTypeId} />
							</div>
						</PerfectScrollbar>
					</div>
				</CSSTransition>
			</TransitionGroup>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => ({
	enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToProps = (dispatch) => ({
	setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppSidebar);
